import React from 'react';
import type { voters_issueViewFoundation_VotersItemNew$key } from '@atlassian/jira-relay/src/__generated__/voters_issueViewFoundation_VotersItemNew.graphql.ts';
import { Voters } from '../../header/voters/index.tsx';

export const VoteButton = ({
	votesField,
}: {
	votesField?: voters_issueViewFoundation_VotersItemNew$key | null;
}) => <Voters votesField={votesField} isMeatBallMenuOption />;
